/**
 * Компонент быстрых вопросов
 */

import { ChevronRight } from 'lucide-react';
import styles from './QuickQuestions.module.css';
import { SuggestedQuestion } from '@/types/message.types';

/**
 * Пропсы компонента QuickQuestions
 */
interface QuickQuestionsProps {
  /** Массив быстрых вопросов */
  questions: SuggestedQuestion[];
  /** Колбек при клике на вопрос */
  onQuestionClick: (question: string) => void;
}

/**
 * Список быстрых вопросов
 * 
 * @description Отображает suggested questions с анимациями
 */
export function QuickQuestions({ questions, onQuestionClick }: QuickQuestionsProps) {
  if (questions.length === 0) {
    return null;
  }

  return (
    <div className={styles.quickQuestions} role="list">
      {questions.map((question, index) => (
        <button
          key={question.id || index}
          className={styles.questionBtn}
          onClick={() => onQuestionClick(question.text)}
          type="button"
          role="listitem"
        >
          <span className={styles.text}>{question.text}</span>
          <span className={styles.arrow}>
            <ChevronRight size={16} strokeWidth={2} />
          </span>
        </button>
      ))}
    </div>
  );
}

